export interface AuthContextGroup {
  id: string;
  name: string;
  description?: string;
  runTask?: boolean;
  adminExtractData?: boolean;
  modifyEmbargoKeyword?: boolean;
  modifyUrlExceptions?: boolean;
  modifySkuChecker?: boolean;
}

export interface useCallbackInterface {
  (
    uid: string,
    token: string,
    role: string,
    expirationDate: Date | null,
    group: AuthContextGroup,
    adminGroup: string[]
  ): void;
}

export enum AdminsRole {
  ADMIN = 'ADMIN',
  SUPERADMIN = 'SUPERADMIN'
}

export enum Role {
  USER = 'USER',
  ADMIN = AdminsRole.ADMIN,
  SUPERADMIN = AdminsRole.SUPERADMIN
}
